export default __webpack_public_path__ + "static/media/maxine_side.87976949.jpg";